import React, { useState } from 'react';

import { Route, Routes } from 'react-router-dom';

import { AddCardPayment } from './AddCardPayment';
import { DeleteCard } from './DeleteCard';

import { renderBnplLayout } from '../BnplLayout';

export const PaymentInstrumentNavigator = () => {
  const [cardList, setCardList] = useState([]);
  const saveCardHandler = (card) => setCardList([...cardList, card]);
  const deleteCardHandler = (id) => {
    setCardList(cardList.filter((el) => el.cardId !== id));
  };

  return renderBnplLayout(
    <Routes>
      <Route
        path="/addCard"
        element={<AddCardPayment cardList={cardList} handler={saveCardHandler} />}
      />
      <Route
        path="/deleteCard"
        element={<DeleteCard cardList={cardList} handler={deleteCardHandler} />}
      />
    </Routes>
  );
};
